// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});


let fadeOptions = {
	"duration": 200,
	"delay": 0
};

const playVideo = () => {
	$w('#videoPlaceholder, #videoPlayBtn').hide('fade', fadeOptions)
		.then(() => $w('#callcenterVideo').show('fade', fadeOptions))
		.then($w('#callcenterVideo').play())
}

export function videoPlayBtn_click(event) {
	//Add your code for this event here: 
	playVideo();
}